/**
 * Spotlight — destaca elemento adicionando classe CSS direto nele.
 *
 * Zero cálculo de posição: o navegador desenha outline+glow seguindo o elemento
 * automaticamente. Funciona em qualquer layout (flex, grid, sticky, etc).
 *
 * Quando target é null/undefined: nada acontece (steps fullscreen).
 */
import { useEffect } from 'react';

interface SpotlightProps {
  /** CSS selector do elemento a destacar (null/undefined = nada) */
  target: string | null | undefined;
}

const ACTIVE_CLASS = 'onb-active-target';

export function Spotlight({ target }: SpotlightProps) {
  useEffect(() => {
    if (!target) return;

    // Tenta encontrar o elemento — pode demorar um tick pro DOM montar
    let attempts = 0;
    let cleanupEl: Element | null = null;

    const findAndMark = () => {
      const el = document.querySelector(target);
      if (el) {
        el.classList.add(ACTIVE_CLASS);
        // Garante visibilidade no viewport
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        cleanupEl = el;
        return true;
      }
      return false;
    };

    if (!findAndMark()) {
      // Retry com pequeno delay (caso DOM ainda esteja montando)
      const interval = setInterval(() => {
        attempts++;
        if (findAndMark() || attempts > 20) clearInterval(interval);
      }, 50);
      return () => {
        clearInterval(interval);
        if (cleanupEl) cleanupEl.classList.remove(ACTIVE_CLASS);
      };
    }

    return () => {
      if (cleanupEl) cleanupEl.classList.remove(ACTIVE_CLASS);
    };
  }, [target]);

  return null;
}
